module.exports = __webpack_public_path__ + "img/perso-5.cc6f4ecc.png";